
$(function(){
  $('.select-custom .selectedOption').click(function(){
    $('.options-custom').not($(this).siblings('.options-custom')).addClass('hide');
    $(this).siblings('.options-custom').toggleClass('hide');
  });

  $('.select-custom .options-custom span').click(function(){
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    $(this).closest('.select-custom').find('.selectedOption').attr('value',$(this).attr('value'));
    $(this).closest('.select-custom').find('.selectedOption').text($(this).text());
    $(this).parent('.options-custom').toggleClass('hide');
    
  })
  
  $('.deliveryToggle .options-custom span').click(function(){
    let modalParent = $(this).closest('form');
    modalParent.find('.orderAheadToggle, .orderNowToggle').removeClass('opened');
    modalParent.find('.'+$(this).attr('value')).addClass('opened');
    if($(this).attr('value') == 'orderNowToggle'){
    	modalParent.find('[name="properties[Day]"]').val(modalParent.find('[presentday=1]').attr('value'))
        modalParent.find('[name="properties[Time Slot]"]').val('Now')
        modalParent.find('[name="properties[Delivery Time]"]').val('')
    }
    if($(this).attr('value') == 'orderAheadToggle'){
    	let luncOver = modalParent.find('select option[value="Lunch"]').attr('disabled')
        if (typeof luncOver !== 'undefined' && luncOver !== false) {
         	   modalParent.find('[name="properties[Time Slot]"]').val('Dinner')
               modalParent.find('.customSelectSlot').find('.options-custom span[value="Dinner"]').addClass('selected')
               modalParent.find('.customSelectSlot').find('.selectedOption').text('Dinner')
               modalParent.find('.customSelectSlot').find('.selectedOption').attr('value','Dinner')
        }
      	else{
      		modalParent.find('[name="properties[Time Slot]"]').val('Lunch')
            modalParent.find('.customSelectSlot').find('.options-custom span[value="Lunch"]').addClass('selected')
            modalParent.find('.customSelectSlot').find('.selectedOption').text('Lunch')
            modalParent.find('.customSelectSlot').find('.selectedOption').attr('value','Lunch')
      	}
    }
  })
  
  
//   $('.select-custom .selectedOption').bind('DOMSubtreeModified', function(){
//   	console.log('changed');
//   });
  
  
  $('.selectDay').each(function(){
  	let selected = $(this).siblings('.customSelectDay').find('.selectedOption')
    selected.attr('value',$(this).val());
    selected.text($(this).find('option:selected').text());
    selected.siblings('.options-custom').find('span[value="'+$(this).val()+'"]').addClass('selected')
  })
  
  
  
  $('.customSelectDay .options-custom span').click(function(){
    $(this).closest('.customSelectDay').siblings('.selectDay').val($(this).attr('value'));
//     $(this).closest('.customSelectDay').siblings('.selectDay').change();
    changeSelect($(this).closest('.customSelectDay').siblings('.selectDay'))
//     console.log('custDay',$(this).closest('.customSelectDay'))
  })
  $('.customSelectSlot .options-custom span').click(function(){
    $(this).closest('.customSelectSlot').siblings('.selectSlot').val($(this).attr('value'));
//     $(this).closest('.customSelectSlot').siblings('.selectSlot').change();
//     console.log('custSlot')
  })
  
  $('.selectDay').change(function(){
    let selected = $(this).siblings('.customSelectDay').find('.selectedOption')
  	selected.siblings('.options-custom').find('span[value="'+$(this).val()+'"]').click();
    selected.siblings('.options-custom').addClass('hide')
  })
  
  $('.selectSlot').change(function(){
    let selected = $(this).siblings('.customSelectSlot').find('.selectedOption')
  	selected.siblings('.options-custom').find('span[value="'+$(this).val()+'"]').click();
    selected.siblings('.options-custom').addClass('hide')
  })
  
  
  function changeSelect(elem){
//     	console.log('elem',elem)
    	let slot = elem.siblings('.selectSlot');
        if(elem.find(":selected").attr('presentDay') == 1){
        	let parentelement = elem.closest('.modal-content');
            slot.find('option.orderNow').show();
        	updateSubmitButtonStateForModal(parentelement);
        }
        else{
      		slot.find('option').removeAttr('disabled')
            slot.find('option.orderNow').hide();
          	slot.val('Lunch')
            elem.siblings('.customSelectSlot').find('.options-custom span').removeClass('disabled selected')
            elem.siblings('.customSelectSlot').find('.options-custom span[value="Lunch"]').addClass('selected')
            elem.siblings('.customSelectSlot').find('.selectedOption').text('Lunch')
            elem.siblings('.customSelectSlot').find('.selectedOption').attr('value','Lunch')
            
        	let mainElement = elem.closest('form.form');
//           	console.log(mainElement.html())
          	mainElement.find('.modal-error-message').css('visibility','hidden');
          	mainElement.find('.product-form__buttons').addClass('active');
        }
    }

  $('.deliverySlot .options-custom span').click(function(){
    let input = $(this)
    setTimeout(function(){
      if($(input).parents('.deliverySlot').find('.selectedOption').attr('value') == "Now"){
        $(input).parents('.subsciption-modal').find('.select-wrap').addClass('hide');
      }
      else{
        $(input).parents('.subsciption-modal').find('.select-wrap').removeClass('hide');
      }
    },100)
  })
  
});